// @ts-nocheck
import React from "react";
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { useUsuarios } from "../State/UsuarioContext";
import { forwardRef } from 'react';
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import SinapTheme from "../../styles/SinapTheme";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useBody } from "../../Body/state/BodyContext";
import { EXTENSION_MAIL_INSTITUCIONAL, RUTA_API_USUARIOS, URL_API_SIA } from "../../Contantes/Constantes";
import { Button } from '@mui/material';
import Divider from '@mui/material/Divider';
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import ChipColor from "../../Componentes/ChipColor";
import { TiempoRestante } from "./TiempoRestante";
import KeyCloak from "../../Auth/Keycloak";
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import SinapThemev2 from "../../styles/SinapThemev2";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { useHistory } from "react-router-dom";
import ModalCrearSolicitud from "./ModalCrearSolicitud";
import { useAuth } from "../../Auth/State/AuthContext";
import Tabla from "../../Componentes/Tabla";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const useStyles = makeStyles(theme => ({
    typografy: {
        marginTop: '2%',
        width: "100%",
        color: SinapTheme.palette.primary.main,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-start',
        '& > *': {
            margin: "8px",
        },
        flexGrow: 1,
        maxWidth: 752,
    },
    label: {
        paddingLeft: "16px",
        paddingTop: "14.4px"
    },
    header_forms: {
        textDecoration: 'underline'
    }
}))

const responsive = [
    {
        title: 'Correo de envio', field: 'emailDestinatario',
        cellStyle: {
            textAlign: 'center'
        },
        headerStyle: {
            textAlign: 'center'
        }
    },
    {
        title: 'Tiempo Restante', field: 'tiempoRestante',
        cellStyle: {
            textAlign: 'center'
        },
        headerStyle: {
            textAlign: 'center'
        },
        render: rowData => <div> <TiempoRestante fecha={rowData.tiempoRestante} id={rowData.id} />
        </div>,
    }
]

const AgregarSolicitud = ({ onClick }) => {

    return (
        <Tooltip title="Crear solicitud">
            <Fab sx={[{ zIndex: 1, backgroundColor: SinapThemev2.palette.primary.main }, { '&:hover': { backgroundColor: SinapThemev2.palette.primary.light } }]} onClick={onClick} aria-label="add">
                <PostAddIcon fontSize="large" sx={{ color: '#ffffff' }} />
            </Fab>
        </Tooltip>
    )
}

export const Solicitudes = ({ }) => {
    let history = useHistory();
    const { solicitudes, getSolicitudes } = useUsuarios();
    const [botonesAcciones, setBotonesAcciones] = React.useState([]);
    const { setMessage, setSuccess } = useBody();
    const columns = React.useMemo(() =>
        [
            {

                accessorKey: 'nombreSolicitante',

                header: 'Pedido por',

                size: 100,

            },
            {

                accessorKey: 'emailDestinatario',

                header: 'Correo de envio',

                size: 100,

            },
            {

                accessorKey: 'tiempoRestante',

                header: 'Tiempo Restante',

                size: 100,

                Cell: rowData => <div><TiempoRestante fecha={rowData.row.original.tiempoRestante} id={rowData.id} /></div>

            }
        ])
    const [openModalSolicitud, setOpenModalSolicitud] = React.useState(false);
    const matches = useMediaQuery('(min-width:1185px)');
    const classes = useStyles();
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { user, hasRole } = useAuth();



    React.useEffect(() => {
        history.push({
            pathname: '/usuarios/alta',
            search: '?tab=1'
        })

        if (hasRole(["ROLE_CREAR_SOLICITUD"])) {
            setBotonesAcciones(prevState => [...prevState, <AgregarSolicitud onClick={() => setOpenModalSolicitud(true)} />])
        }

        getSolicitudes()
    }, [])


    return (
        <Box sx={{ px: matches ? 2 : 0 }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={2} px={2} >
                <Typography
                    my={matches ? "40px" : "20px"}
                    mx="10px"
                    fontSize={matches ? "30px" : "28px"}
                >
                    Solicitudes de formulario
                </Typography>
                <div style={{ display: "flex", justifyContent: "center", marginRight: "10px" }}>
                    {botonesAcciones.map(boton => {
                        return boton
                    })}
                </div>
            </Box>

            <Tabla
                columns={columns}
                data={solicitudes}
                enableFullScreenToggle={false}
                enableColumnResizing={matches ? false : true}
                layoutMode='grid'
            />

            <ModalCrearSolicitud open={openModalSolicitud} onClose={() => setOpenModalSolicitud(false)} getSolicitudes={() => getSolicitudes()} />
        </Box>
    )
}